import styled from "styled-components";

export const Audio = ({ src }) => {
  return <StyledAudio controls src={src} />;
};
const StyledAudio = styled.audio`
  max-width: 100%;
  max-height: 100%;
`;
